import { useEffect, useState } from "react";
import { Alert, Form, Modal } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import { userSignal } from "../../../signal/userSignal";
import { DEV_SERVER } from "../../../constants/urls";
import axios from "axios";
import { CreatePaymentReceipt } from "../tally/sync/payment";
import { organisationSignal } from "../../../signal/organisationSignal";


export default function TallyPaymentModal(props) {

    const [payment, setPayment] = useState(props?.payment)
    const [bankAccount, setBankAccount] = useState({})
    const [company, setCompany] = useState(organisationSignal?.value?.tallyConfig?.companies[0]?.companyName || "")
    const [_bankAccounts, setBankAccounts] = useState([])
    const [voucherType, setVoucherType] = useState("")
    const [_salesVoucherTypes, setSalesVoucherTypes] = useState([])

    const getBankAccounts = () => {
        let _bankAccount = JSON.parse(window.localStorage.getItem(`tally-${company}-bank-ledgers`))

        _bankAccount = _bankAccount?.ENVELOPE?.BODY?.DATA?.COLLECTION?.LEDGER || []

        if (!(_bankAccount instanceof Array)) {
            _bankAccount = [_bankAccount]
        }

        _bankAccount = [..._bankAccount, { _attributes: { NAME: "Cash" } }]

        return _bankAccount
    }

    const getSalesVoucherTypes = () => {
        let _salesVoucherTypes = JSON.parse(window.localStorage.getItem(`tally-${company}-receipt-voucher-types`))

        _salesVoucherTypes = _salesVoucherTypes?.ENVELOPE?.BODY?.DATA?.COLLECTION?.VOUCHERTYPE || []

        if (!(_salesVoucherTypes instanceof Array)) {
            _salesVoucherTypes = [_salesVoucherTypes]
        }

        return _salesVoucherTypes
    }

    const markOrderAsSynced = useMutation(async (data) => {
        let resp = await axios.put(`${DEV_SERVER}/payment/v2/markPaymentSyncedWithTally/${data?.id}`, data?.body, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        onSuccess: (data) => {
            if (data.status) {
                toast.success(data.message);
                props.refetchPayments()
                props.close()
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error?.response?.data?.message);
            }
        }
    });


    useEffect(() => {
        if (props?.payment) {
            setPayment(props?.payment)
        }
    }, [props])


    useEffect(() => {
        setBankAccounts(getBankAccounts())
        setSalesVoucherTypes(getSalesVoucherTypes())
    }, [company])

    const handleSync = async () => {
        let resp = await CreatePaymentReceipt({ payment, bankAccount, company, voucherType })

        if (resp) {

            let dealer = payment?.dealerId || []

            if (!(dealer instanceof Array)) {
                dealer = [dealer]
            }

            dealer = dealer[0]

            let body = {
                voucherNumber: resp,
                voucherType: voucherType?._attributes?.NAME,
                bankAccount: bankAccount?._attributes?.NAME,
                companyName: company !== "" ? company : organisationSignal?.value?.tallyConfig?.companies[0]?.companyName,
                dealerName: dealer?.name,
            }

            let masterId = ""

            if (dealer?.tallyDetails) {
                let idx = 0;
                for (let i = 0; i < dealer?.tallyDetails.length; i++) {
                    if (dealer?.tallyDetails[i]?.companyName === body?.companyName) {
                        idx = i
                        break
                    }
                }

                masterId = dealer?.tallyDetails[idx]?.masterId
            }

            body.dealerMasterId = masterId

            markOrderAsSynced.mutate({ id: payment?.id, body: body })

        } else {
            toast.error("Failed to sync with Tally")
        }
    }

    return (
        <Modal show={props?.show} onHide={props?.close} style={{ height: "100%", width: "100%" }}>
            <Modal.Header closeButton>
                <Modal.Title>Sync With Tally</Modal.Title>
            </Modal.Header>

            <Modal.Body>

                {(organisationSignal?.value?.tallyConfig?.companies && organisationSignal?.value?.tallyConfig?.companies?.length > 0) && <Form.Group className="mb-3 col-12 mt-5 align-self-center" controlId="formBasicName">
                    <Form.Label>Select Company</Form.Label>
                    <Select
                        options={organisationSignal?.value?.tallyConfig?.companies?.map((company) => ({ value: company?.companyName, label: company?.companyName }))}
                        placeholder="Select Company"
                        onChange={(e) => {
                            if (e && e?.value) {
                                setCompany(e?.value)
                            } else {
                                setCompany("")
                            }
                        }}
                        value={{ value: company, label: company }}
                        isClearable
                    />
                </Form.Group>}


                <Form.Group className="mb-3 col-12 mt-5 align-self-center" controlId="formBasicName">
                    <Form.Label>Select Voucher Type</Form.Label>
                    <Select
                        options={_salesVoucherTypes.map((voucher) => ({ value: voucher, label: voucher?._attributes?.NAME }))}
                        placeholder="Select Voucher Type"
                        onChange={(e) => {
                            if (e && e?.value) {
                                setVoucherType(e?.value)
                            }
                        }
                        }
                        value={{ value: voucherType, label: voucherType?._attributes?.NAME }}
                        isClearable
                    />
                </Form.Group>

                <Form.Group className="mb-3 col-12 mt-5 align-self-center" controlId="formBasicName">
                    <Form.Label>Select Bank Accounts</Form.Label>
                    <Select
                        options={_bankAccounts.map((account) => ({ value: account, label: account?._attributes?.NAME }))}
                        placeholder="Select Sales Account"
                        onChange={(e) => {
                            console.log(e)
                            if (e && e?.value) {
                                setBankAccount(e?.value)
                            } else {
                                setBankAccount({})
                            }
                        }}
                        value={{ value: bankAccount, label: bankAccount?._attributes?.NAME }}
                        isClearable
                    />
                </Form.Group>



            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn-light" onClick={props?.onHide}>Close</button>
                <button className="btn btn-primary" onClick={handleSync}>Sync</button>
            </Modal.Footer>
        </Modal>
    )
}